import React, { Fragment } from 'react';

import ProductComponent from '../Layout/ProductComponent';
import styled from 'react-emotion';

import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import { Pagination, PaginationBehaviour } from '@jetshop/ui/Pagination';

const PaginationWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  button {
    display: inline-block;
    font-size: 0.85rem;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    text-decoration: none;
    font-weight: bold;
    color: #333;
    background: #efefef;
    padding: 0.5rem 1rem;
    border: 1px solid #dfdfdf;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -ms-border-radius: 0;
    border-radius: 0;
    &:disabled {
      visibility: hidden;
    }
  }
`;

const Row = styled('div')`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  margin: 0.5rem 0;

  &::after {
    content: ' ';
    display: block;
    flex: auto;
  }
`;

const Products = ({ products }) => {
  if (products.result.length < 1) {
    return <Fragment />;
  }
  return (
    <Fragment>
      <Row>
        {products.result.map((product, key) => (
          <ProductComponent product={product} productsPerRow="4" key={key} />
        ))}
      </Row>
      <PaginationWrapper>
        <PaginationContext.Consumer>
          {({ currentPage, goToPage, perPage }) => (
            <PaginationBehaviour
              currentPage={currentPage}
              goToPage={goToPage}
              perPage={perPage}
              total={products.totalResults}
            >
              {props => <Pagination {...props} />}
            </PaginationBehaviour>
          )}
        </PaginationContext.Consumer>
      </PaginationWrapper>
    </Fragment>
  );
};

export default Products;
